import { create } from "zustand";
import { combine, createJSONStorage, persist } from "zustand/middleware";

export const adminStore = create(
  persist(
    combine(
      {
        userProfile: null,
      },
      (set) => ({
        setUserProfile: (userProfile) => set({ userProfile }),
      })
    ),
    { name: "park-pay-admin", storage: createJSONStorage(() => localStorage) }
  )
);
